import ReactDOM from 'react-dom/client';
import reportWebVitals from "./reportWebVitals";
import Root from "./root";
import "@abgov/web-components";
import { bootstrapDomainKeyRedirect, establishBridgedSession } from "./MPP-Common-SPA/utils/globalUtility";
import { ensureEntraAuthenticated } from "./ServiceUtils/entraGate";

const renderApplication = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<Root />);
  reportWebVitals();
};

// Tracks the current startup phase so a failure can be attributed to the specific
// step that threw (Entra gate probe, domain-key redirect, or session bridge).
let bootstrapPhase = "entra-gate";

// On staff-gated environments, ensure an EasyAuth (Entra) session exists before bootstrapping.
// No-op (returns true) unless REACT_APP_ENTRA_GATE_ENABLED === "true".
ensureEntraAuthenticated()
  .then((continueBootstrap) => {
    if (!continueBootstrap) {
      // A full-page redirect to the EasyAuth login is in progress.
      return;
    }

    bootstrapPhase = "domain-key-redirect";
    return bootstrapDomainKeyRedirect().then(async (isRedirecting) => {
      if (isRedirecting) {
        return;
      }

      // On the target program sub-domain, silently bridge the source portal session
      // (if any) before rendering so the app loads already authenticated.
      bootstrapPhase = "session-bridge";
      await establishBridgedSession();
      renderApplication();
    });
  })
  .catch((error) => {
    console.error(`Bootstrap failed during "${bootstrapPhase}" phase`, error);
    renderApplication();
  });